$(($) => {
	const viewBox = `<svg viewBox="0 0 443 717">
    								<use href="#g-icon.svg"></use>
  								</svg>`;
	$('.bs-slider--r-tesslr-l7-glb1 .slick-slide-wrapper').prepend(viewBox);
});
